export default {
    baseStyle: {
        // this is provided as style prop to the toast container holding the alert
        // does not support theme references - e.g. sizes
        container: {
            width: '100%',
            maxWidth: '100%',
            margin: 0,
            padding: 0
        }
    },
    parts: ['container']
}
